class CTOHeader extends HTMLElement {
  constructor() {
    super();
    this.isMobile = false;
  }

  connectedCallback() {
    this.addEvents();
    this.updateShareButtonUrlInCollectionView();
    window.updateShareButtonUrlInCollectionView = this.updateShareButtonUrlInCollectionView;
  }

  addEvents() {
    this.isMobile = window.matchMedia(
      "only screen and (max-width: 1023px)"
    ).matches;

    // const $header = this;
    // const $headerSticky = document.querySelector('.js-cto-header-sticky');
    // const stickyHeight = $headerSticky.offsetHeight
    // const opts = {
    //   root: null,
    //   rootMargin: `-${stickyHeight}px 0px 0px 0px`,
    //   threshold: 0
    // };

    // const observer = new IntersectionObserver((entries) => {
    //   entries.forEach((entry) => {
    //     if (entry.isIntersecting) {
    //       this.isIntersecting = true;
    //       $headerSticky.classList.remove('is-visible');
    //       this.scrollDirection(this.isIntersecting);
    //     } else {
    //       this.isIntersecting = false;
    //       $headerSticky.classList.add('is-visible');
    //       this.scrollDirection(this.isIntersecting);
    //     }
    //   });
    // }, opts);

    // observer.observe($header);

    // document.addEventListener('headerSticky', (e) => {
    //   const { isSticky } = e.detail;
    //   if (isSticky) {
    //     $headerSticky.classList.add('header-is-sticky');
    //   } else {
    //     $headerSticky.classList.remove('header-is-sticky');
    //   }
    // });
  }

  updateShareButtonUrlInCollectionView() {
    if (window.ctoCollection) {
      const $shareButtons = document.querySelectorAll('share-button');
      $shareButtons.forEach(($shareButton) => {
        const $input = $shareButton.querySelector('input');
        if ($input) {
          $input.value = window.location.href;
        }
      });
    }
  }

  scrollDirection(isIntersecting) {
    if (!this.isMobile) { return; }

    // Initial state
    let scrollPos = 0;
    const $headerSticky = document.querySelector('.js-cto-header-sticky');

    // Add scroll event
    window.onscroll = function() {
      // Detect new state and compare it with the previous state
      const scrollUp = (document.body.getBoundingClientRect()).top > scrollPos;
      if (scrollUp && !isIntersecting) {
        $headerSticky.classList.add('is-visible');
      } else if (!scrollUp && !isIntersecting) {
        $headerSticky.classList.remove('is-visible');
      }
      // Save the new position for iteration
      scrollPos = (document.body.getBoundingClientRect()).top;
    };

    window.onscroll();
  }
}

customElements.define('cto-header', CTOHeader);
